import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyExploreNodeView } from './zyexplore-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyExplore: {
            insertZyExplore: () => ReturnType;
        };
    }
}

export const ZyExploreHeadless = Node.create({
    name: 'zyExplore',

    content: function () {
        return getBasicContentSchema();
    },

    group: 'block',

    draggable: true,

    isolating: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyExplore',
                getAttrs: element => {
                    if (!(element instanceof HTMLElement)) {
                        return false;
                    }
                    return {
                        id: element.getAttribute('id'),
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyExplore', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyExplore:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: 'zyExplore',
                        content: [
                            {
                                type: 'bulletList',
                                content: [
                                    {
                                        type: 'listItem',
                                        content: [
                                            {
                                                type: 'paragraph',
                                                attrs: {
                                                    textAlign: null,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    });
                },
        };
    },
});

export const ZyExplore = ZyExploreHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyExploreNodeView);
    },
});

export default ZyExplore;
